import { useDispatch } from 'react-redux';
import { useGraphql } from 'utils/hooks/useGraphql';

import { fetchCampaignSchedulerMsgParams } from 'api/queries/experiments';
import { ScheduleType } from 'modules/domains/campaign';
import { addNegativeToast, errorIdentifier } from 'modules/toastContainer';
import { useExperimentsTranslations } from './useTranslations';

type CampaignSchedulerRequest = {
  id: number;
};

type CampaignSchedulerResponse = {
  campaign: {
    schedulerMsgParams: {
      scheduleType: ScheduleType;
    };
  };
};

const source = 'useCampaignSchedulerMsgParams';

export const useCampaignSchedulerMsgParams = (campaignId: number, fetchData: boolean) => {
  const { t } = useExperimentsTranslations();
  const dispatch = useDispatch();
  const errorToasterMessage = t('errorMessage.fetchCampaignSchedulerMsgParams');

  const fetchCampaignScheduleType = () => {
    const {
      data: { campaign } = {},
      errorMessage: error,
    } = useGraphql<CampaignSchedulerResponse, CampaignSchedulerRequest>(
      fetchCampaignSchedulerMsgParams,
      {
        variables: {
          id: campaignId,
        },
      },
    );

    if (error) {
      dispatch(
        addNegativeToast(
          errorToasterMessage,
          errorIdentifier({
            source,
            error,
          }),
        ),
      );
    }

    return campaign?.schedulerMsgParams?.scheduleType ?? ScheduleType.ProjectTimeZone;
  };

  const fetchFallbackCampaignScheduleType = () => ScheduleType.ProjectTimeZone;

  /**
   * We need this setting just for blast campaigns.
   * So, this flag gives us the ability to not make a
   * remote call for other types of experiment
   * */
  return fetchData ? fetchCampaignScheduleType : fetchFallbackCampaignScheduleType;
};
